import '@splidejs/react-splide/css';

import React from 'react';
import classNames from 'classnames';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import styles from './Carousel.module.css';
import Icon from '@/components/ui/Icon';
import { Size } from '@/types/enums';

type CarouselProps = {
  infinite?: boolean,
  optionalClasses?: string
};

export default function Carousel(
  {
    children,
    infinite = true,
    optionalClasses = '',
  }: React.PropsWithChildren<CarouselProps>,
): React.ReactElement {
  return (
    <Splide
      className={classNames(styles.carousel, optionalClasses)}
      aria-label="Drops promo carousel"
      hasTrack={false}
      options={{
        type: infinite ? 'loop' : 'rewind',
        pauseOnHover: false,
        speed: 1500,
        resetProgress: false,
        autoplay: true,
        pauseOnFocus: false,
        classes: {
          page: classNames('splide__pagination__page', styles['carousel__navigation-item']),
        },
      }}
    >
      <SplideTrack className={optionalClasses}>
        {
          (children as React.ReactNode[])
            .map((item, index) => (
              <SplideSlide
                key={`carousel-item-${index + 1}`}
                className={classNames(styles.carousel__item, optionalClasses)}
              >
                {item}
              </SplideSlide>
            ))
        }
      </SplideTrack>
      <div className={classNames('splide__arrows', styles['carousel__navigation-panel'])}>
        <button className={classNames('splide__arrow--prev', styles['carousel__navigation-arrow'])}>
          <Icon iconName="icon_chevron_right" size={Size.SMALL} />
        </button>
        <ul
          className={classNames(
            'splide__pagination',
            'splide__pagination--ltr',
            styles['carousel__navigation-panel'],
          )}
          role="tablist"
          aria-label="Select a slide to show"
        />
        <button className={classNames('splide__arrow--next', styles['carousel__navigation-arrow'])}>
          <Icon iconName="icon_chevron_right" size={Size.SMALL} />
        </button>
      </div>
    </Splide>
  );
}
